import { Component, OnInit, OnDestroy, HostListener, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';

import { LoaderService } from './loader.service';
import { LoaderState } from './loader';

@Component({
	selector: 'loader',
	template: `
    <div [class.loader-hidden]="!show">
        <div class="loader-backdrop" [ngStyle]="{'width.px': screenWidth, 'height.px': screenHeight}"></div>
        <div class="loader-overlay" [ngStyle]="{'width.px': screenWidth, 'height.px': screenHeight}">
            <dx-load-indicator
                id="large-indicator"
                height="100"
                width="100"
            ></dx-load-indicator>
        </div>
    </div>`,
	styleUrls: ['loader.component.css']
})
export class LoaderComponent implements OnInit, OnDestroy {

	constructor(
		private loaderService: LoaderService,
		private elRef: ElementRef
	) { }
	screenHeight: number;
	screenWidth: number;

	show = false;

	private subscription: Subscription;

	@HostListener('window:resize', ['$event'])
	getScreenSize(event?) {
			this.screenHeight = window.innerHeight;
			this.screenWidth = window.innerWidth;
	}

	ngOnInit() {
		this.screenHeight = window.innerHeight;
		this.screenWidth = window.innerWidth;

		this.subscription = this.loaderService.loaderState
			.subscribe((state: LoaderState) => {
				const parentHeight = this.elRef.nativeElement.parentNode.offsetHeight;
				this.screenHeight = parentHeight > 0 ? parentHeight : window.innerHeight;
				this.screenWidth = window.innerWidth;
				this.show = state.show;
			});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}
}
